import { call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { getAccessToken } from 'ctm-app/client/sagas/utils/tokens';
import { pageContext } from 'ctm-util-functions';
import { PREFILL_INELIGIBLE_BRANDS } from 'ctm-components/components/prefill/utils';
import { getBrand } from 'ctm-app/client/store/selectors';
import { reporterLog } from 'ctm-app/client/sagas/reporter';
/**
 * Saga for loading prefill data from Journey prefill/verify endpoint
 * @param {Object} action - The action that describes the request payload and next page name.
 * if nextPageName in action.payload is not provided, it will redirect will be handled by the next page button behavior (progression model).
 * currently, only car need to pass this nextPageName, hc doesn't.
 * @returns {void}
 */
export const processPrefillVerifyAction = function* (action) {
    const { requestPayload, nextPageName, preventPrefill, replaceOnFailure, verifyParams = {} } = action.payload;
    const vertical = yield select((state) => state.getIn(['page', 'vertical']));
    const journeyUrl = yield select((state) => state.getIn(['serverConfig', 'journeyServiceBaseUrl']));
    const env = yield select((state) => state.getIn(['serverConfig', 'env']));
    const brandCode = yield select(getBrand);
    const queryString = window?.location?.search;

    try {
        const hasPrefillCandidate = sessionStorage.getItem('has_prefill_candidate');

        if (!PREFILL_INELIGIBLE_BRANDS.includes(brandCode) && hasPrefillCandidate === 'true' &&  !preventPrefill) {
            yield put({ type: 'SET_IS_VERIFYING', payload: true });

            // Use the saga token function instead of local getAccessTokens
            const accessToken = yield call(getAccessToken);

            const anonId = sessionStorage.getItem('user_anonymous_id');
            const verifyEndpoint = `${journeyUrl}${env === 'local' ? '' : '/'}journey/prefill/verify`;

            const response = yield call(axios.post, verifyEndpoint, requestPayload, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: {
                    anonymous_id: anonId,
                    brand_code: brandCode,
                    ...verifyParams
                }
            });

            yield put({ type: 'SET_VERIFY_RESPONSE', payload: response });
            yield put({ type: 'SET_IS_VERIFYING', payload: false });
            yield put({ type: 'SET_SHOW_WELCOME_BACK', payload: true });

            sessionStorage.setItem('last_viewed_page', response.data.prefill.lastViewedPage);
            if (nextPageName) {
                /*
                Browser history model is often represented by a LinkedList.
                * push adds a new node
                * replace take the current node and updates it to another
                So, we can still go back, but
                * instead of appending `welcome_back` in front of `car_colour`,
                * we're replacing `car_colour` with `welcome_back`
                */
                pageContext.getProps().browserHistory.replace({
                    pathname: `/${vertical}/journey/welcome_back`,
                    search: queryString
                });
            }
        } else if (nextPageName) {
            pageContext.getProps().browserHistory.push(`/${vertical}/journey/${nextPageName}`);
        }
    } catch (error) {
        yield put({ type: 'SET_IS_VERIFYING', payload: false });
        yield put({ type: 'SET_SHOW_WELCOME_BACK', payload: false });
        if (nextPageName) {
            const browserHistory = pageContext.getProps().browserHistory;
            const navigationMethod = replaceOnFailure ? 'replace' : 'push';
            browserHistory[navigationMethod](`/${vertical}/journey/${nextPageName}`);
        }
        if (error.response?.status === 404) {
            yield put({ type: 'PREFILL_VERIFY_FAIL' }); // for Data team to check failed prefill verify.
        } else {
            yield put({ type: 'SET_VERIFY_FAILED' }); // unexpected error, set verify failed state.
            yield call(reporterLog, action, error);
        }
    }
};
